/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineAvailableTagBatchResponse {
    getFixupPrototypeFunction() { return TagBaselineAvailableTagBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineAvailableTagBatchResponse>): TagBaselineAvailableTagBatchResponse {
        let obj = Object.assign(new TagBaselineAvailableTagBatchResponse(), model);
        TagBaselineAvailableTagBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineAvailableTagBatchResponse>): TagBaselineAvailableTagBatchResponse {
        if (!model) return null;
        return TagBaselineAvailableTagBatchResponse.newInstance(<TagBaselineAvailableTagBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineAvailableTagBatchResponse) {
        if (!obj) return;

        models.TagBaselineAvailableTagBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineAvailableTagBatchResponse): boolean {
        Object.setPrototypeOf(obj, TagBaselineAvailableTagBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagBaselineAvailableTag.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagBaselineAvailableTag; };

}
